import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { IconName } from '@optimus-web/icons';
import { TextKey } from '@mews-commander/enums';
import { useLocalizeText } from '@mews/framework';
import { IconButtonProps, getDisableClickAwayProps } from '@optimus-web/core';
import { isAppSidebarOpened } from '../../appSidebar/reducer';
import { SideBarIconButton } from './styles';

const SidebarButton = ({ opened, onClick, ...other }: { onClick?: $TSFixMeFunction; opened?: boolean }) => {
    const localizeText = useLocalizeText();

    const commonProps: Partial<IconButtonProps> = {
        id: 'menu-trigger',
        onClick,
        variant: 'ghost',
        iconSize: 'medium',
        ...getDisableClickAwayProps(),
        ...other,
    };

    return (
        <>
            <SideBarIconButton
                icon={IconName.MenuArrowLeft}
                aria-label={localizeText({ textKey: TextKey.Close })}
                hide={!opened}
                type="button"
                {...commonProps}
            />
            <SideBarIconButton
                icon={IconName.MenuArrowRight}
                aria-label={localizeText({ textKey: TextKey.Open })}
                hide={opened}
                type="button"
                {...commonProps}
            />
        </>
    );
};

export default connect(
    createStructuredSelector({
        opened: isAppSidebarOpened,
    }),
    null,
    null,
    { forwardRef: true }
)(SidebarButton);
